/**
 * The launcher's icons — v1's, from `frontend/src/lib/WidgetLauncher.svelte`,
 * with the SVG attributes renamed for React. Drawing, so Class C.
 */
import type { ReactElement } from "react";

export const ICONS: Record<string, ReactElement> = {
  health: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 12h3l2.5-7 4 14 3-9 2 2h3.5" />
    </svg>
  ),
  turner: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9" />
      <polyline points="12 7 12 12 15.5 12" />
    </svg>
  ),
  finance: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="14" width="4" height="7" rx="1" />
      <rect x="9" y="9" width="4" height="12" rx="1" />
      <rect x="16" y="4" width="4" height="17" rx="1" />
    </svg>
  ),
  canvas: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M8 12h8M12 8v8" />
    </svg>
  ),
  todos: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 11l3 3L22 4" />
      <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
    </svg>
  ),
  drive: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 19H2l4.5-8h11z" />
      <path d="M2 19l4.5-8 4 7z" stroke="none" fill="currentColor" opacity={0.15} />
      <path d="M13.5 11L9 3h6l4.5 8z" stroke="none" fill="currentColor" opacity={0.15} />
      <path d="M9 3h6l7 16H8z" />
      <path d="M9 3L2 19" />
    </svg>
  ),
  journal: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="4" y="2" width="13" height="20" rx="2" />
      <line x1="8" y1="7" x2="13" y2="7" />
      <line x1="8" y1="11" x2="13" y2="11" />
      <line x1="8" y1="15" x2="11" y2="15" />
      <path d="M17 2h1a2 2 0 012 2v16a2 2 0 01-2 2h-1" />
    </svg>
  ),
  worldmap: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M2 12h20" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  digitalwellbeing: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="5" y="2" width="14" height="20" rx="2" />
      <line x1="12" y1="18" x2="12" y2="18.5" strokeWidth={2.5} strokeLinecap="round" />
      <line x1="8" y1="7" x2="16" y2="7" />
      <line x1="8" y1="11" x2="14" y2="11" />
    </svg>
  ),
  recipes: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 11l4-8h10l4 8" />
      <path d="M3 11h18v2a7 7 0 0 1-7 7h-4a7 7 0 0 1-7-7v-2z" />
      <path d="M12 11v9" />
    </svg>
  ),
  goals: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1.4" fill="currentColor" />
    </svg>
  ),
  piano: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="5" width="18" height="14" rx="1.5" />
      <line x1="8" y1="5" x2="8" y2="19" />
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="16" y1="5" x2="16" y2="19" />
      <rect x="6.5" y="5" width="3" height="8" rx="0.5" fill="currentColor" stroke="none" />
      <rect x="10.5" y="5" width="3" height="8" rx="0.5" fill="currentColor" stroke="none" />
      <rect x="14.5" y="5" width="3" height="8" rx="0.5" fill="currentColor" stroke="none" />
    </svg>
  ),
  atlas: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="7" y="3" width="13" height="13" rx="1.5" />
      <path d="M4 7v12a1.5 1.5 0 0 0 1.5 1.5H17" />
      <circle cx="11" cy="7.5" r="1.4" />
      <path d="M9 13l2.5-3 3 3.5" />
    </svg>
  ),
  notes: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 3h9l4 4v12.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 4 19.5v-15A1.5 1.5 0 0 1 5.5 3" />
      <path d="M14 3v4h4" />
      <line x1="8" y1="12" x2="15" y2="12" />
      <line x1="8" y1="16" x2="13" y2="16" />
    </svg>
  ),
  reading: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 6.5C10.5 5 8 4.5 4 4.5v13c4 0 6.5.5 8 2 1.5-1.5 4-2 8-2v-13c-4 0-6.5.5-8 2z" />
      <path d="M12 6.5V20.5" />
    </svg>
  ),
  domestic: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 10.5L12 3l9 7.5" />
      <path d="M5 9.5V21h14V9.5" />
      <circle cx="12" cy="15" r="3" />
      <path d="M12 13.4v1.6l1.1 1.1" />
    </svg>
  ),
  audiobooks: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 15V11a8 8 0 0 1 16 0v4" />
      <rect x="2.5" y="14.5" width="4" height="6" rx="1.6" />
      <rect x="17.5" y="14.5" width="4" height="6" rx="1.6" />
    </svg>
  ),
  internals: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="2" />
      <circle cx="5" cy="6" r="1.6" />
      <circle cx="19" cy="6" r="1.6" />
      <circle cx="5" cy="18" r="1.6" />
      <circle cx="19" cy="18" r="1.6" />
      <line x1="12" y1="12" x2="5" y2="6" />
      <line x1="12" y1="12" x2="19" y2="6" />
      <line x1="12" y1="12" x2="5" y2="18" />
      <line x1="12" y1="12" x2="19" y2="18" />
    </svg>
  ),
  // New in v2 (unit 29A): a house with a key-hole, for what only the owner has.
  executive: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 11l9-7 9 7" />
      <path d="M5 10v10h14V10" />
      <circle cx="12" cy="14" r="1.6" />
      <path d="M12 15.6V18" />
    </svg>
  ),
  settings: (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  ),
};

/** v1's launcher labels, where they are not the widget's title. */
export const LAUNCHER_LABELS: Record<string, string> = {
  health: "Health",
  turner: "Turner",
  finance: "Finance",
  canvas: "Canvas",
  todos: "Todos",
  drive: "Drive",
  journal: "Journal",
  worldmap: "Maps",
  digitalwellbeing: "Wellbeing",
  recipes: "Recipes",
  goals: "Goals",
  piano: "Piano",
  atlas: "Atlas",
  notes: "Notes",
  reading: "Reading",
  domestic: "Domestic",
  audiobooks: "Audiobooks",
  internals: "Internals",
  executive: "Executive",
  settings: "Settings",
};
